export default {
    topics: [
        {
            title: ' Cancel ',
            href: 'sm-offer-Cancel.html',
            attributes: { 'data-id': 'sm-offer-Cancel' },
            menu: { hasChildren: false },
            tocID: 'sm-offer-Cancel-d66e3269',
            topics: [],
        },
        {
            title: ' CheckValidationAccess ',
            href: 'sm-offer-CheckValidationAccess.html',
            attributes: { 'data-id': 'sm-offer-CheckValidationAccess' },
            menu: { hasChildren: false },
            tocID: 'sm-offer-CheckValidationAccess-d66e3277',
            topics: [],
        },
        {
            title: ' Complete ',
            href: 'sm-offer-Complete.html',
            attributes: { 'data-id': 'sm-offer-Complete' },
            menu: { hasChildren: false },
            tocID: 'sm-offer-Complete-d66e3285',
            topics: [],
        },
        {
            title: ' Deploy ',
            href: 'sm-offer-Deploy.html',
            attributes: { 'data-id': 'sm-offer-Deploy' },
            menu: { hasChildren: false },
            tocID: 'sm-offer-Deploy-d66e3293',
            topics: [],
        },
        {
            title: ' DeployPublish ',
            href: 'sm-offer-DeployPublish.html',
            attributes: { 'data-id': 'sm-offer-DeployPublish' },
            menu: { hasChildren: false },
            tocID: 'sm-offer-DeployPublish-d66e3301',
            topics: [],
        },
        {
            title: ' GetCompatibleOfferViews ',
            href: 'sm-offer-GetCompatibleOfferViews.html',
            attributes: { 'data-id': 'sm-offer-GetCompatibleOfferViews' },
            menu: { hasChildren: false },
            tocID: 'sm-offer-GetCompatibleOfferViews-d66e3309',
            topics: [],
        },
        {
            title: ' StartValidation ',
            href: 'sm-offer-StartValidation.html',
            attributes: { 'data-id': 'sm-offer-StartValidation' },
            menu: { hasChildren: false },
            tocID: 'sm-offer-StartValidation-d66e3317',
            topics: [],
        },
        {
            title: ' Validation ',
            href: 'sm-offer-Validation.html',
            attributes: { 'data-id': 'sm-offer-Validation' },
            menu: { hasChildren: false },
            tocID: 'sm-offer-Validation-d66e3325',
            topics: [],
        },
    ],
};

